module.exports = __webpack_public_path__ + "static/icon-viz-da3ca7f7e2b2379a1eaf5f181dc37bf2.png";